import { computed } from 'mobx';

export default class StationTypeModel {
  id;
  store;

  constructor(store, item) {
    this.store = store;
    this.id = +item.id;
    this.name = item.name;
    this.description = item.description;
    this.parent_id = item.parent_id;
    this.icon = item.icon;
  }

  @computed get asJson() {
    return {
      id: +this.id,
      name: this.name,
      description: this.description,
      parent_id: this.parent_id,
      icon: this.icon,
    };
  }

  updateFromJson(item) {
    this.id = +item.id;
    this.name = item.name;
    this.description = item.description;
    this.parent_id = item.parent_id;
    this.icon = item.icon;
  }
}



// WEBPACK FOOTER //
// ./src/models/StationTypeModel.js